import {useNavigate} from "react-router-dom";
import {useBaseUrlCreateFlow} from "../../../services/urlServices";

export default function useFormSubmit(){
    const navigateTo = useNavigate();
    const baseUrl = useBaseUrlCreateFlow();
    return function(data){
        navigateTo(`${baseUrl}/step4/verifycode/${data.code}`);
    }
}
